import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {DealPayrollGroupSettings} from '../../../models/deal-payroll.model';
import {dealPayrollBlockerKeys} from '../../../models/deal-payroll-presentation';
import {DealPayrollSettingsService} from '../../../services/deal-payroll-settings.service';
import {
  DEAL_PAYROLL_CATALOG_EMPTY_KEY,
  DEAL_PAYROLL_CATALOG_EMPTY_LENGTH,
  DEAL_PAYROLL_CATALOG_INITIAL_SEQUENCE,
  DEAL_PAYROLL_CATALOG_LOAD_ERROR_KEY,
  DEAL_PAYROLL_CATALOG_STRING_TYPE,
  DEAL_PAYROLL_CONFIGURATION_NEEDS_ATTENTION_KEY,
  DEAL_PAYROLL_CONFIGURATION_READY_KEY,
  DEAL_PAYROLL_CONFIGURATION_SERVER_DISABLED_KEY
} from './deal-payroll-catalog.constants';
import {DealPayrollCatalogView} from './deal-payroll-catalog.types';

@Component({
  selector: 'app-deal-payroll-catalog',
  templateUrl: './deal-payroll-catalog.component.html',
  styleUrls: ['./deal-payroll-catalog.component.css']
})
export class DealPayrollCatalogComponent implements OnInit, OnDestroy {
  rows: DealPayrollCatalogView[] = [];
  loading = false;
  errorKey = DEAL_PAYROLL_CATALOG_EMPTY_KEY;

  private sequence = DEAL_PAYROLL_CATALOG_INITIAL_SEQUENCE;
  private destroy$ = new Subject<void>();

  constructor(private settingsService: DealPayrollSettingsService) {}

  ngOnInit(): void {
    this.load();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  load(): void {
    if (this.loading) {
      return;
    }
    const sequence = ++this.sequence;
    this.loading = true;
    this.errorKey = DEAL_PAYROLL_CATALOG_EMPTY_KEY;
    this.settingsService.getDealPayrollCatalog().takeUntil(this.destroy$).subscribe(
      (response: DealPayrollGroupSettings[]) => this.applyResponse(response, sequence),
      () => this.setLoadError(sequence)
    );
  }

  trackByGroupId(_index: number, row: DealPayrollCatalogView): string {
    return row.groupId;
  }

  trackByBlocker(_index: number, key: string): string {
    return key;
  }

  private applyResponse(response: DealPayrollGroupSettings[], sequence: number): void {
    if (sequence !== this.sequence) {
      return;
    }
    if (!this.validCatalog(response)) {
      this.setLoadError(sequence);
      return;
    }
    this.rows = response.map((settings: DealPayrollGroupSettings) => this.catalogView(settings));
    this.loading = false;
  }

  private validCatalog(response: DealPayrollGroupSettings[]): boolean {
    return Array.isArray(response) && response.every((settings: DealPayrollGroupSettings) =>
      !!settings && typeof settings.groupId === DEAL_PAYROLL_CATALOG_STRING_TYPE
      && settings.groupId.trim().length > DEAL_PAYROLL_CATALOG_EMPTY_LENGTH
      && Array.isArray(settings.payrollPositions) && Array.isArray(settings.grades)
      && Array.isArray(settings.areas) && Array.isArray(settings.coefficientUnits));
  }

  private catalogView(settings: DealPayrollGroupSettings): DealPayrollCatalogView {
    const groupName = normalizedName(settings.groupName);
    return {
      groupId: settings.groupId,
      groupName: groupName,
      missingGroupName: !groupName,
      blockerKeys: dealPayrollBlockerKeys(settings.blockers),
      statusKey: configurationStatusKey(settings)
    };
  }

  private setLoadError(sequence: number): void {
    if (sequence === this.sequence) {
      this.rows = [];
      this.loading = false;
      this.errorKey = DEAL_PAYROLL_CATALOG_LOAD_ERROR_KEY;
    }
  }
}

function normalizedName(value: string): string {
  return typeof value === DEAL_PAYROLL_CATALOG_STRING_TYPE
    ? value.trim() : DEAL_PAYROLL_CATALOG_EMPTY_KEY;
}

function configurationStatusKey(settings: DealPayrollGroupSettings): string {
  if (settings.calculationEnabled !== true) {
    return DEAL_PAYROLL_CONFIGURATION_SERVER_DISABLED_KEY;
  }
  return settings.eligible === true && !(settings.blockers || []).length
    ? DEAL_PAYROLL_CONFIGURATION_READY_KEY : DEAL_PAYROLL_CONFIGURATION_NEEDS_ATTENTION_KEY;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/deal-payroll-catalog/deal-payroll-catalog.component.ts